import { ConvertHistoryListPage } from "@/features/convert/pages/ConvertHistoryList";
import { ConvertFilterCacheProvider } from "@/features/convert/provider/ConvertListFilterCacheProvider";

function ConvertHistoryList() {
  return (
    <ConvertFilterCacheProvider>
      <ConvertHistoryListPage />
    </ConvertFilterCacheProvider>
  );
}

export default ConvertHistoryList;
